import PrimaryNavigation from './PrimaryNavigation'

export default PrimaryNavigation
